import SalesPointListView from '@/views/sales-point/SalesPointListView'
import SalesPointsView from '@/views/sales-point/SalesPointsView'
import SalesPointCreateView from '@/views/sales-point/SalesPointCreateView'
import SalesPointView from '@/views/sales-point/SalesPointView'
import SalesPointEditView from '@/views/sales-point/SalesPointEditView'
import SalesPointMapView from '@/views/sales-point/SalesPointMapView'

import { SALES_POINTS, SALES_POINT_CREATE, SALES_POINT_EDIT, SALES_POINT, SALES_POINT_LIST, SALES_POINT_MAP } from '@/routes/sales-point'

export default [
  {
    path: '/sales-points/:companyId',
    component: SalesPointsView,
    props: true,
    meta: {
      root: SALES_POINTS,
      titleKey: 'salespoints.title',
      mainRoutes: [ SALES_POINT_MAP, SALES_POINT_LIST ]
    },
    children: [
      {
        path: 'map',
        name: SALES_POINT_MAP,
        component: SalesPointMapView,
        props: true,
        meta: {
          titleKey: 'salespointMap.title'
        }
      },
      {
        path: '',
        name: SALES_POINT_LIST,
        component: SalesPointListView,
        meta: {
          titleKey: 'salespointList.title'
        },
        children: [
          {
            path: 'create',
            name: SALES_POINT_CREATE,
            component: SalesPointCreateView,
            meta: {
              titleKey: 'salespointCreate.title'
            }
          },
          {
            path: ':salesPointId',
            name: SALES_POINT,
            component: SalesPointView,
            props: true,
            meta: {
              titleKey: 'salespoint.title'
            }
          },
          {
            path: ':salesPointId/edit',
            name: SALES_POINT_EDIT,
            component: SalesPointEditView,
            props: true,
            meta: {
              titleKey: 'salespointEdit.title'
            }
          }
        ]
      }
    ]
  }
]
